import { Checkbox, Col, Form, Input, Row } from 'antd'
import { translate } from '../../translate'
import React, { useState } from 'react'
import { SearchMode, SearchOptions } from './type'
import classNames from 'classnames'

let labelSequence = 0

export type SearchParameterItemProps = {
  index: number
  option: SearchOptions<any>
  mode: SearchMode
}

export const SearchParameterItem = ({ index, option, mode }: SearchParameterItemProps) => {
  const [isActive, setIsActive] = useState<boolean>(option.defaultActive ?? false)
  const [labelId] = useState(() => `search-parameter-label-${++labelSequence}`)

  if (option.valueType === 'threeState')
    return (
      <Row gutter={[16, 4]} className='mt-1'>
        <Col xs={24} xxl={8} className='d-flex align-items-center'>
          <label id={labelId} style={{ fontSize: 12 }}>
            {option.label}
          </label>
        </Col>

        <Col xs={24} xxl={16}>
          <Form.Item
            noStyle
            name={[index, 'value']}
          >
            {option.render?.({ isActive: true, index, labelId })}
          </Form.Item>
        </Col>
      </Row>
    )

  return (
    <Row gutter={[16, 16]} className='mt-1'>
      <Col span={8}>
        <Form.Item
          noStyle
          name={[index, 'isActive']}
          valuePropName="checked"
        >
          <Checkbox
            onChange={e => setIsActive(e.target.checked)}
            style={{ fontSize: 12 }}
          >
            {option.label}
          </Checkbox>
        </Form.Item>
      </Col>

      <Col
        span={9}
        className='d-flex align-items-center'
      >
        {option.formItemDisabled
          ? option.render?.({isActive, index})
          : <Form.Item
            noStyle
            name={[index, 'value']}
            rules={[
              {
                required: isActive && mode === SearchMode.Search && option.valueType !== 'boolean',
                message: translate(option.label, 'required'),
              }
            ]}>
            {
              option.render
                ? option.render({ isActive, index })
                :
                <Input
                  disabled={!isActive}
                />
            }
          </Form.Item>
        }
      </Col>

      <Col
        span={7}
        className={classNames('d-flex align-items-center', option.hideExactMatch ? 'd-none' : '')}
      >
        <Form.Item
          noStyle
          name={[index, 'exactMatch']}
          valuePropName="checked"
        >
          <Checkbox
            style={{ fontSize: 12 }}
            disabled={!isActive}
          >
            {translate('exact_match')}
          </Checkbox>
        </Form.Item>
      </Col>
    </Row>
  )
}
